import React, { useState } from "react";
import { Dropdown, MenuItem } from "react-bootstrap";

const SurveyActionMenu = ({ id, actions = [], disabled = false }) => {
  const [open, setOpen] = useState(false);

  const selectAction = (action) => {
    setOpen(false);
    if (action.onSelect) action.onSelect();
  };

  return (
    <Dropdown
      id={id}
      open={open}
      pullRight
      className="survey-action-menu"
      onToggle={(nextOpen) => setOpen(Boolean(nextOpen))}
    >
      <Dropdown.Toggle
        bsSize="small"
        disabled={disabled}
        className="survey-engine-action-button survey-action-menu-toggle"
      >
        <i
          className="fa fa-ellipsis-h survey-engine-button-icon"
          aria-hidden="true"
        />
        <span>More</span>
      </Dropdown.Toggle>
      <Dropdown.Menu pullRight>
        {actions.filter(Boolean).map((action) => (
          <React.Fragment key={action.key}>
            {action.dividerBefore && <MenuItem divider />}
            <MenuItem
              disabled={action.disabled}
              className={action.danger ? "survey-action-menu-danger" : ""}
              onSelect={() => selectAction(action)}
            >
              <i className={`fa ${action.icon}`} aria-hidden="true" />
              <span>{action.label}</span>
            </MenuItem>
          </React.Fragment>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SurveyActionMenu;
